import React, { useEffect, useState } from 'react';
import { Calendar } from 'react-date-range';
import moment from 'moment';
import { Images, newDateWithoutUtc, SaveParams } from 'utils';
import { Popper } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { enUS } from 'date-fns/locale';
import { ErrMessage } from '../messages';
import { TypableDateInput } from './constants';

export const DateTypeSelect = ({
    outLabel,
    handleGetDates,
    values,
    error,
    type,
    noError,
    name,
    max,
    min,
    resetValue,
    noRemoveBtn,
    width,
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const info = values ? values : location?.state;
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;
    const [state, setState] = useState();
    const valueFromRoute = info?.[name];

    // const testMin = new Date(min);
    // const testMax = new Date(max);
    //
    //
    // if (min) {
    //     const momentMin = moment(min);
    //     const year = momentMin.year();
    //     const month = momentMin.month();
    //     const day = momentMin.date();
    //     testMin.setFullYear(year);
    //     testMin.setMonth(month);
    //     testMin.setDate(day);
    //     testMin.setHours(0, 0, 0, 0);
    // }
    //
    // if (max) {
    //     const momentMax = moment(max);
    //     const year = momentMax.year();
    //     const month = momentMax.month();
    //     const day = momentMax.date();
    //     testMax.setFullYear(year);
    //     testMax.setMonth(month);
    //     testMax.setDate(day);
    //     testMax.setHours(0, 0, 0, 0);
    // }

    // console.log(testMin, 'testMin');
    // console.log(testMax, 'testMax');
    // console.log(min, 'min');

    const customLocale = {
        ...enUS,
        options: {
            ...enUS.options,
            weekStartsOn: 0,
        },
    };

    useEffect(() => {
        if (valueFromRoute) {
            setState(moment.utc(valueFromRoute).format('YYYY-MM-DD'));
        } else {
            if (resetValue) {
                setState(null);
            }
        }
    }, [info]);

    const handleDateChange = (item) => {
        const formattedDate = moment(item).format('YYYY-MM-DD');
        setState(formattedDate);

        if (handleGetDates) {
            handleGetDates({ target: { value: formattedDate, name: name } });
        } else {
            const params = {
                ...info,
            };
            params[name] = formattedDate;
            SaveParams(navigate, params);
        }
        setAnchorEl(null);
    };

    const handleClear = () => {
        setState(null);

        if (handleGetDates) {
            handleGetDates({ target: { value: '', name: name } });
        } else {
            const params = {
                ...info,
            };
            delete params[name];
            SaveParams(navigate, params);
        }
    };

    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleTypeDate = (value) => {
        const date = value?.toString();

        if (isValidDate(date)) {
            const parsed = moment.utc(value, 'YYYY-MM-DD');
            const dateObject = parsed.toDate();
            const minDate = min ? new Date(min) : null;
            const maxDate = max ? new Date(max) : null;
            const isWithinRange = (!minDate || dateObject >= minDate) && (!maxDate || dateObject <= maxDate);

            if (isWithinRange) {
                setState(parsed.format('YYYY-MM-DD'));
            } else {
                console.warn('Date is out of range');
            }
        } else {
            console.warn('Invalid date format');
        }
    };

    const handleBlur = () => {
        const newValue = state ? moment.utc(state).format('YYYY-MM-DD') : null;
        // Guard: `info?.[name]` may be empty. moment.utc(undefined) defaults to "now", so an empty
        // existing value must be treated as null — otherwise typing today's date reads as "unchanged"
        // and never propagates to the parent.
        const existingValue = info?.[name] ? moment.utc(info[name]).format('YYYY-MM-DD') : null;
        const checkIsNotSame = newValue && newValue !== existingValue;

        if (checkIsNotSame) {
            if (handleGetDates) {
                handleGetDates({ target: { value: newValue, name: name } });
            } else {
                const params = {
                    ...info,
                };
                params[name] = newValue;
                SaveParams(navigate, params);
            }
        }
    };

    const isValidDate = (dateString) => {
        const date = new Date(dateString);
        return !isNaN(date.getTime());
    };

    return (
        <div style={{ width: width ? width : '100%' }}>
            {outLabel && (
                <p
                    style={type === 'modalInput' ? { color: error ? '#FE7070' : valueFromRoute ? '#347AF0' : '#51566D' } : {}}
                    className={type === 'modalInput' ? 'modal-date-selector-label' : 'date-selector-label'}
                >
                    {outLabel}
                </p>
            )}
            <button
                onClick={handleClick}
                style={
                    error
                        ? { borderColor: '#FE7070', color: '#FE7070' }
                        : type === 'modalInput'
                          ? { width: '100%' }
                          : { width: '165px', justifyContent: 'space-between' }
                }
                className={type === 'modalInput' ? 'modal-date-range-selector-dos' : 'date-range-selector'}
                aria-describedby={id}
                type={'button'}
            >
                <div
                    className="date-range-inputs"
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                    }}
                >
                    <TypableDateInput
                        onBlur={handleBlur}
                        placeholder="mm/dd/yyyy"
                        value={state ? moment.utc(state).toDate() : null}
                        onChange={(date) => {
                            if (date && new Date(date) > new Date(2045, 11, 31)) return; // Prevent selecting beyond 2045
                            handleTypeDate(date);
                        }}
                    />
                    {/*<DateInput*/}
                    {/*    onBlur={handleBlur}*/}
                    {/*    placeholder={'mm/dd/yyyy'}*/}
                    {/*    format="MM/dd/yyyy"*/}
                    {/*    value={state ? moment.utc(state).toDate() : null}*/}
                    {/*    onChange={handleTypeDate}*/}
                    {/*    minDate={new Date(2000, 0, 1)}*/}
                    {/*    maxDate={new Date(2045, 11, 31)}*/}
                    {/*/>*/}
                </div>
                <div className="flex-align-center">
                    {state && !noRemoveBtn && (
                        <button
                            className="remove-calendar-day"
                            type={'button'}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleClear();
                            }}
                        >
                            <img src={Images.removeBlack} alt="remove" />
                        </button>
                    )}
                    <img src={Images.calendarToday} alt="icon" />
                </div>
            </button>
            {!noError && <ErrMessage text={error} />}
            <Popper
                id={id}
                open={open}
                anchorEl={anchorEl}
                className={'modal-custom-date-selector-box'}
                placement="bottom-start"
                style={{ position: 'absolute', zIndex: 1400 }}
            >
                <Calendar
                    date={state ? moment(state).toDate() : min ? moment(min).toDate() : new Date()}
                    onChange={handleDateChange}
                    locale={customLocale}
                    maxDate={max ? newDateWithoutUtc(max) : undefined}
                    minDate={min ? newDateWithoutUtc(min) : undefined}
                />
                {!noRemoveBtn && (
                    <button type={'button'} className="clear-bnt" onClick={handleClear}>
                        Clear
                    </button>
                )}
            </Popper>
            {open && <div className="beck-drop" onClick={() => setAnchorEl(null)} />}
        </div>
    );
};
